import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { createStyles } from '@material-ui/core/styles';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const ConfirmDeleteModal: React.FC<{
  open: boolean;
  content: React.ComponentElement<any, any>;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}> = (props) => {
  const classes = useStyles();
  return (
    <Dialog
      open={props.open}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description">
      <Box className={classes.modalDeleteContainer}>
        <Typography variant="h5">Confirmation</Typography>
        <Box className={classes.labelModal}>{props?.content}</Box>
        <Box className={classes.buttonDeleteModalContainer}>
          <Button onClick={props.onCancel}>Annuler</Button>
          <Button style={{ color: 'red' }} onClick={props.onConfirm}>
            {props?.confirmLabel}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalDeleteContainer: {
      backgroundColor: '#fff',
      padding: 20,
    },
    buttonDeleteModalContainer: {
      marginTop: 12,
    },
    labelModal: {
      marginTop: 20,
    },
  }),
);

export default ConfirmDeleteModal;
